var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 12 18",
    fill: "#f8f8f8",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svelte-e3a2ae",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19464 11.4C7.19464 12.06 6.65962 12.595 5.99964 12.595C5.33966 12.595 4.80464 12.06 4.80464 11.4C4.80464 10.74 5.33966 10.205 5.99964 10.205C6.65962 10.205 7.19464 10.74 7.19464 11.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9671 6.57023H10.1951V4.19546C10.1951 1.87837 8.31673 0 5.99964 0C3.68255 0 1.80418 1.87837 1.80418 4.19546V6.57023H0.0322266V14.99C0.0322266 16.6469 1.37537 17.99 3.03223 17.99H8.96706C10.6239 17.99 11.9671 16.6469 11.9671 14.99V6.57023ZM8.9951 4.19546V6.57023H3.00418V4.19546C3.00418 2.54111 4.3453 1.2 5.99964 1.2C7.65399 1.2 8.9951 2.54111 8.9951 4.19546ZM1.23223 14.99V7.77023H10.7671V14.99C10.7671 15.9841 9.96117 16.79 8.96706 16.79H3.03223C2.03811 16.79 1.23223 15.9841 1.23223 14.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.576f498140a19d942b345a4b4c7a2c8f.svg";
export { ForwardRef as ReactComponent };